import React from "react";
import PowderSlider from "../PowderSlider/PowderSlider";
import ResourcesSection from "../ResourcesSection/ResourcesSection";

const ResourcesPage = () => {
  return (
    <>
      

      {/* Component 2 */}
      <ResourcesSection />
      {/* Component 1 */}
      <PowderSlider />
    </>
  );
};

export default ResourcesPage;
